import lottieWeb from "lottie-web";

window.lottie = lottieWeb;
